<div class="content" (click)="outAnimation()">

	<app-groups></app-groups>

</div>
